<div class="energy-expense" [class.energy-expense--small]="size === 'small'">
    <!-- Header -->
    <header class="energy-expense__header">
        <div class="header-content">
            <div class="energy-expense__title">{{ title }}</div>
            <div class="header-actions">
                <!-- Edit Pencil (only in edit mode) -->
                <ng-container *ngIf="isEditMode">
                    <div class="pencil-wrapper" (click)="toggleSizeDropdown(index, $event); $event.stopPropagation()"
                        cdkOverlayOrigin #editTrigger="cdkOverlayOrigin">
                        <img src="assets/icons/img-pencil.svg" class="pencil-icon" alt="Edit size" />
                    </div>
                    <app-widget-edit [editTrigger]="editTrigger" [index]="index"
                        [activeDropdownIndex]="activeDropdownIndex" [getAvailableSizes]="getAvailableSizes"
                        [changeWidgetSize]="changeWidgetSize" [removeWidget]="removeWidget"
                        [toggleSizeDropdown]="toggleSizeDropdown">
                    </app-widget-edit>
                </ng-container>

                <ng-container *ngIf="isAddMode">
                    <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                        alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
                </ng-container>
            </div>
        </div>
    </header>

    <!-- Main Content -->
    <div class="energy-expense__content">
        <!-- Left Section: Icon and Amount -->
        <div class="left-section">
            <div class="icon-amount-wrapper">
                <div class="icon-wrapper">
                    <div class="icon-emoji">{{ emoji }}</div>
                </div>
                <div class="amount-info">
                    <div class="amount">{{ amount }}</div>
                    <div class="period-label">{{ periodLabel }}</div>
                </div>
            </div>
        </div>

        <!-- Right Section: Bars and Comparison -->
        <div class="right-section" *ngIf="size !== 'small'">
            <div class="bars-container">
                <div class="bar-item" *ngFor="let bar of monthlyData">
                    <div class="bar-label">{{ bar.month }}</div>
                    <div class="bar-fill" [style.width]="bar.percentage + '%'"></div>
                </div>
            </div>
            <div class="comparison-info">
                <div class="comparison-percentage">
                    <span class="percentage-value">{{ comparisonPercentage }}</span>
                    <img src="assets/icons/img_frame-1171275423.svg" class="trend-icon" alt="Trend" />
                </div>
                <div class="comparison-label">{{ comparisonLabel }}</div>
            </div>
        </div>

        <!-- Small Size: Compact View -->
        <div class="small-view" *ngIf="size === 'small'">
            <div class="small-comparison">
                <img src="assets/icons/img_frame-1171275423.svg" class="trend-icon-small" alt="Trend" />
                <span class="percentage-small">{{ comparisonPercentage }}</span>
            </div>
        </div>
    </div>
</div>